
import { Vue, Component } from 'vue-property-decorator';
import { getList } from '../api';
import { List } from 'vant';
import { ImagePreview } from 'vant';
Vue.use(List).use(ImagePreview);
@Component
export default class Home extends Vue {
  tabs: any = [
    { text: '全部', id: 0 },
    { text: '买房装修', id: 1 },
    { text: '网络购物', id: 2 },
    { text: '教育培训', id: 3 },
    { text: '其他', id: 4 },
  ];
  id: number = 0;
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;

  show: boolean = true;

  // mounted() {
  //   this.reset();
  // }
  changTab(index: number) {
    this.id = index;
    this.reset();
  }
  goOut() {
    window.location.href = 'https://wap.cqcb.com/shangyou_news/PublishDiscover';
  }

  onLoad() {
    getList(this.id, this.page).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    this.finished = true;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  reset() {
    this.list = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
  showImg(url: any, index: any) {
    console.log(url, index);
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: url, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
